<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <g fill="none" stroke="currentColor" stroke-width="1.5">
        <circle stroke="none" cx="7" cy="7" r="7"/>
        <circle cx="7" cy="7" r="6.25"/>
    </g>
    <path fill="currentColor" d="M7,1.063v6h5.813a3.811,3.811,0,0,0-1.187-4.187A8.289,8.289,0,0,0,7,1.063Z"/>
</svg>
</template>